import React, {useState} from "react";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import InputFile from "../../../shared/controls/inputFile";
import useApiViaje from "../../../api/operaciones/useApiViajes";
import {Message} from "primereact/message";

const ProgramacionPenskeUploader = ({onUploaded})=>{

    const api = useApiViaje();

    const [visible, setVisible] = useState(false    )
    const [archivo, setArchivo] = useState()
    const [warnings, setWarnings] = useState([])

    const onUpload =async ()=>{
        const formData = new FormData();
        formData.append("file", archivo?.file);
        const result = await api.subirPlan(formData)
        setWarnings(result)
        setArchivo(null)
    }

    const onOpen =()=>{
        setArchivo(null)
        setVisible(true)
        // setLoading(false)
    }

    const renderFooterModal = () => {
        return (
            <div className="p-1">
                <Button label="Cancelar" onClick={()=>setVisible(false)} className="tn btn-sm p-button-outlined" />
                <Button label="Actualizar Viajes" disabled={archivo == null} onClick={onUpload} type="button" className="tn btn-sm" />
            </div>
        );
    };

    return (
        <>
            <button
                type="button"
                onClick={onOpen}
                className={`btn btn-sm btn-primary`}
            >
                Programación Penske
            </button>

            <Dialog header={`Subir Programacion`}
                    footer={renderFooterModal}
                    visible={visible} onHide={()=>setVisible(false)} style={{width: '600px'}}>
                <div style={{display:'flex', alignItems:'center', gap:'15px'}}>
                    <div style={{paddingBottom:'5px'}}>Seleccionar Archivo </div>
                    <InputFile value={archivo} onChange={setArchivo} />
                </div>
                {warnings.length > 0 && archivo == null &&
                    <Message style={{width:'100%', display:'flex', flexDirection:'column',
                        justifyContent:'flex-start', fontSize:'0.8em',
                        alignItems:'flex-start'}
                    } severity="warn" content={
                        <ul style={{margin:'0', paddingLeft:'20px'}}>
                            {warnings.map((w,i)=><li key={i}>{w}</li>)}
                        </ul>
                    } />
                }
            </Dialog>

        </>
    )
}
export default ProgramacionPenskeUploader;